// Layer order MUST be established before any layered CSS loads (quasar-layer.sass)
import './styles/layer-order.css';
import { createPinia } from 'pinia';
import { Quasar } from 'quasar';
import { createApp, type Plugin } from 'vue';

import {
  createPostHogBeforeSend,
  postHogVuePlugin,
} from '@grasp-gg/lib-web-analytic/web';

import './styles/material-icons-layer.css';
import './styles/quasar-layer.sass';
import App from './App.vue';
import router from './router';
import './styles/tailwind.css';
import './assets/main.sass';

const app = createApp(App);

app.use(Quasar as Plugin, {});

// Anonymous shell telemetry ($pageview / $pageleave / $exception) into the
// shared Grasp PostHog project, segmented by source. The shell embeds
// app.grasp.gg in a cross-origin iframe, so in-app usage is captured there
// under source='app' and is intentionally invisible to this instance.
// Guarded on a present token so local dev (no .env) doesn't boot a tokenless
// client or emit noise.
if (import.meta.env.VITE_POSTHOG_KEY) {
  app.use(postHogVuePlugin, {
    source: 'ab-inbev',
    token: import.meta.env.VITE_POSTHOG_KEY,
    appVersion: import.meta.env.VITE_VERSION,
    config: {
      ...(import.meta.env.VITE_POSTHOG_HOST && {
        api_host: import.meta.env.VITE_POSTHOG_HOST,
      }),
      before_send: createPostHogBeforeSend(),
    },
  });
}

app.use(createPinia());
app.use(router);

app.mount('#app');
